import { createContext } from "react";
import { AzureFilter } from "../types/AlgoliaTypes";

export const AzureConfigContext = createContext<AzureFilter[]>([]);